import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"delete\">\n    <path id=\"delete_a\" d=\"M5 1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h4a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2h4zM2.069 7l.867 13h8.128l.867-13H2.07zM1 5h12a1 1 0 0 1 .998 1.067l-1 15A1 1 0 0 1 12 22H2a1 1 0 0 1-.998-.933l-1-15A1 1 0 0 1 1 5zm4 12h4a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol